var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_520_7731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3059 4.37158L15.6338 11.0008L22.3059 17.6299C22.4265 17.3778 22.4997 17.0991 22.4997 16.8015V5.19998C22.4997 4.90233 22.4265 4.62368 22.3059 4.37158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5662 3.26562H2.43338C2.13573 3.26562 1.85708 3.3388 1.60498 3.45941L10.1327 11.9442C10.8867 12.6982 12.1129 12.6982 12.8669 11.9442L21.3946 3.45941C21.1425 3.3388 20.8638 3.26562 20.5662 3.26562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.693789 4.37158C0.573176 4.62368 0.5 4.90233 0.5 5.19998V16.8015C0.5 17.0992 0.573176 17.3779 0.693789 17.6299L7.36593 11.0008L0.693789 4.37158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7224 11.9131L13.7783 12.8572C12.5219 14.1136 10.4776 14.1136 9.22123 12.8572L8.27712 11.9131L1.60498 18.5423C1.85708 18.6629 2.13573 18.7361 2.43338 18.7361H20.5662C20.8638 18.7361 21.1425 18.6629 21.3946 18.5423L14.7224 11.9131Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_520_7731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogo);
export default __webpack_public_path__ + "static/media/emailLogo.827c3640d4b89550712a538c20e90b90.svg";
export { ForwardRef as ReactComponent };